import React from 'react';
import {Link} from 'react-router-dom';
import parse from 'html-react-parser';

export function AdditionalResourcesSection({language, prefix, userTrainingPageText}) {
    if (!userTrainingPageText) {
        return null;
    }

    return (
        <section className="cta-bg additional-resources-section" style={{
            padding: '85px 0 137px',
        }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center" style={{marginBottom: '76px'}}>
                        <h2 style={{
                            fontSize: '32px',
                            fontWeight: '300',
                            color: '#04ABA0',
                            fontFamily: 'Roboto',
                            marginBottom: '17px',
                            lineHeight: '1.171875',
                            letterSpacing: '0px'
                        }}>
                            {parse(userTrainingPageText.additionalResourcesTitle)}
                        </h2>
                        <p className="subtitle" style={{
                            fontSize: '24px',
                            fontFamily: 'Roboto',
                            fontWeight: '400',
                            color: '#282828',
                            lineHeight: '1.5',
                            maxWidth: '522px',
                            margin: '0 auto'
                        }}>
                            {parse(userTrainingPageText.additionalResourcesSubtitle)}
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-12" style={{maxWidth: '933px'}}>
                        <div className="resource-block">
                            <div className="resource-block-image">
                                <img
                                    src="/images/icon-1.png"
                                    alt="Animations"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <div className="resource-block-content">
                                <div className="resource-block-text">
                                    <h3>
                                        {parse(userTrainingPageText.animationsTitle)}
                                    </h3>
                                    <p>
                                        {parse(userTrainingPageText.animationsDescription)}
                                    </p>
                                </div>
                                <Link
                                    to={prefix + '/animations'}
                                    className="resource-block-button"
                                >
                                    {parse(userTrainingPageText.findOutMoreButtonText || 'FIND OUT MORE')}
                                </Link>
                            </div>
                        </div>

                        {language !== 'FR-FR' && (
                            <div className="resource-block resource-block-reverse">
                                <div className="resource-block-image">
                                    <img
                                        src="/images/icon-2.png"
                                        alt="Webinars"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                                <div className="resource-block-content">
                                    <div className="resource-block-text">
                                        <h3>
                                            {parse(userTrainingPageText.webinarsTitle)}
                                        </h3>
                                        <p>
                                            {parse(userTrainingPageText.webinarsDescription)}
                                        </p>
                                    </div>
                                    <Link
                                        to={prefix + '/webinars'}
                                        className="resource-block-button"
                                    >
                                        {parse(userTrainingPageText.findOutMoreButtonText || 'FIND OUT MORE')}
                                    </Link>
                                </div>
                            </div>
                        )}

                        <div className="resource-block">
                            <div className="resource-block-image">
                                <img
                                    src="/images/icon-3.png"
                                    alt="Factsheets"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <div className="resource-block-content">
                                <div className="resource-block-text">
                                    <h3>
                                        {parse(userTrainingPageText.factsheetsTitle)}
                                    </h3>
                                    <p>
                                        {parse(userTrainingPageText.factsheetsDescription)}
                                    </p>
                                </div>
                                <Link
                                    to={prefix + '/factsheets'}
                                    className="resource-block-button"
                                >
                                    {parse(userTrainingPageText.findOutMoreButtonText || 'FIND OUT MORE')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
